import { Box, Chip } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { fileControlField } from './FileUploadBody';

export default function FileChips() {
    const methods = useFormContext();
    const selectedFiles = methods.watch(fileControlField) || [];
    const control = methods.control
    const { remove } = useFieldArray({ name: fileControlField, control});

    function handleDeleteFromSelectedFiles(index) {
        remove(index)
    }

    return (
        <>
            {selectedFiles.length > 0 && (
                <Box>
                    {selectedFiles.map((file, index) => (
                        <Chip
                            key={index}
                            label={file.path}
                            onDelete={() => handleDeleteFromSelectedFiles(index)}
                            sx={{
                                margin: "5px",
                                p: 1,
                                justifyContent: "start",
                            }}
                        />
                    ))}
                </Box>
            )}
        </>
    )
}
